import {
  Button,
  Checkbox,
  FormGroup,
  Link,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const StyledFormGroup = styled(FormGroup)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}));

export const StyledFormGroupLabel = styled(Stack)(() => ({
  alignItems: 'start',
  flexDirection: 'row',
}));

export const StyledCheckbox = styled(Checkbox)(() => ({}));
export const StyledCheckboxText = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
}));
export const StyledLink = styled(Link)(() => ({
  color: '#6d77c8',
  '&:hover': {
    color: '#2c3050',
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '1rem',
  width: '100%',
  background: '#6d77c8',
  color: '#ffffff',
  textTransform: 'none',
  lineHeight: '28px',
  padding: theme.spacing(1.5, 2.5),
  borderRadius: theme.spacing(4),
  '.MuiButton-loadingIndicator': {
    color: '#ffffff',
  },
  '&.Mui-disabled': {
    color: '#ffffff',
    opacity: 0.5,
  },
  '&:hover': {
    backgroundColor: '#575fa0',
  },
}));
